import { render, staticRenderFns } from "./LoadingMask.vue?vue&type=template&id=79af450a&"
import script from "./LoadingMask.vue?vue&type=script&lang=js&"
export * from "./LoadingMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports